import { GENDER_TYPES } from '../../constants/ssap/miscellaneous/miscellaneous';
import { getDateDifference } from '../dates/date.utils';

export const getWomanOfReproductiveAge = (hhm, serverDate) => {
    const {
        dateOfBirth,
        gender
    } = hhm;

    const age = getDateDifference(serverDate, dateOfBirth, 'years');

    if(typeof gender === 'string' && gender.toLowerCase() === GENDER_TYPES.FEMALE && (age >= 9 && age <= 66)) {
        return hhm;
    }
};